import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { LOGIN_SUCCESS, SET_MESSAGE } from '../../constants/ActionTypes';

const OAuthCallback = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const data = params.get('data');
    const error = params.get('error');

    if (error) {
      dispatch({ type: SET_MESSAGE, payload: `Login failed: ${error.replace(/_/g, ' ')}` });
      history.replace('/login');
      return;
    }

    if (data) {
      try {
        const userData = JSON.parse(atob(data));
        localStorage.setItem('user', JSON.stringify(userData));
        dispatch({ type: LOGIN_SUCCESS, payload: { user: userData } });
        history.replace('/planner');
      } catch {
        history.replace('/login');
      }
    } else {
      history.replace('/login');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <p>Completing login...</p>
    </div>
  );
};

export default OAuthCallback;
